var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThree(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "#515864"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFF",
    fontSize: 11,
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 6,
    y: 13
  }, "3")))));
}
export default SvgThree;